export default {
  cards: {
    title: "Lékaři a zdravotnická zařízení:",
    list: [
      {
        title: "Dentální hygienistka",
        name: "Lenka Madejová, DiS",
        desc: `Denisova 639/2 <br/>
                    Moravská Ostrava <br/>`,
        tel: "+420 739 805 804",
        web: "http://www.hezkezoubky.cz/",
        email: "lenka.madejova@hezkezoubky.cz",
        photo: "partner_1"
      },
      {
        title: "Ortodoncie",
        name: "MUDr. Agáta Mohammed",
        desc: `Oldřichovice 787 <br/>
                    739 61 Třinec <br/>`,
        tel: "+420 558 348 302",
        web: "www.big-smile.eu",
        email: "contact@big-smile.eu",
      },
      {
        title: "Gynekologická ambulance",
        name: "MUDr. Andrea Polová",
        desc: `Dr. Vančury 401 <br/>
                    Raškovice 260 <br/>
                    Frýdek - Místek <br/>`,
        tel: "+420 558 692 636, +420 558 631 697",
        web: "",
        email: "",
      },
      {
        title: "Kožní ambulance",
        name: "MUDr. Marek Stuchlík",
        desc: `Bayerova 51 <br/>
                    756 61 Rožnov pod Radhoštěm <br/>`,
        tel: "+420 571 65 64 64",
        web: "www.dermatologie.wz.cz"
      },
      {
        title: "Estetické studio",
        name: "Profemina",
        desc: ` Fryštátská 2060 <br/>
                    73301 Karviná 1 <br/>`,
        tel: "+420 777 227 707",
        web: "www.profemina.cz",
      },
      {
        title: "Terapie obezity",
        name: "MUDr. Šárka Malá",
        desc: `Poštovní 155/14 <br/>
                    702 00 Ostrava <br/>`,
        tel: "+420 728 052 950",
        web: "www.lecbaobezity.eu",
        email: "info@lecbaobezity.eu",
      },
      {
        title: "Kožní ambulance Ostrava",
        name: "MUDr. Eva Mlynářová",
        desc: `Prostorná 958/10 <br/> 709 00 Ostrava-Mariánské Hory a Hulváky <br/>`,
        tel: "+420 732 413 139"
      },
      {
        title: "kožní ambulance Ostrava",
        name: "MUDr. Michaela Burdová",
        desc: `Lumírova 639/2 <br/> 700 30 Ostrava-jih <br/>`,
        tel: "+420 596 752 401"
      }
    ]
  }
  /*
  others: {
      title: "Z ostatních lékařů:",
      list: [
          {
              title: "Kožní ambulance, Ostrava",
              name: "MUDr. Eva Mlynářová",
          },
          {
              title: "kožní ambulance Ostrava",
              name: "MUDr. Michaela Burdová",
          }
      ]
  }
  */
}


const example =
  {
    title: "",
    name: "",
    desc: ``,
    tel: "",
    web: "",
    email: "",
    photoId: null
  }
;



// WEBPACK FOOTER //
// ./src/texts/czech/partners.js